import {
  START_LOADING,
  END_LOADING,
  FETCH_INVENTORY_ORDERS,
  FETCH_INVENTORY_ORDER,
  FULFIL_INVENTORY_ORDER,
  CANCEL_INVENTORY_ORDER,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  orders: [],
  currentOrder: null,
  numberOfPages: 0,
  currentPage: 1,
  total: 0,
};

const inventoryOrders = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_INVENTORY_ORDERS:
      return {
        ...state,
        orders: action.payload.orders || [],
        numberOfPages: action.payload.numberOfPages || 1,
        currentPage: action.payload.currentPage || 1,
        total: action.payload.total || 0,
      };

    case FETCH_INVENTORY_ORDER:
      return { ...state, currentOrder: action.payload };

    case FULFIL_INVENTORY_ORDER:
    case CANCEL_INVENTORY_ORDER:
      return {
        ...state,
        orders: state.orders.map((o) =>
          o._id === action.payload._id ? action.payload : o
        ),
        currentOrder:
          state.currentOrder?._id === action.payload._id
            ? action.payload
            : state.currentOrder,
      };

    default:
      return state;
  }
};

export default inventoryOrders;
